import { getCurrencyDecimals } from "@/lib/currency-format"

/** Preserve the entered value; money postings must never silently round. */
export function moneyAmount(value: string, currency: string): string | null {
  const normalized = value.trim().replace(",", ".")
  const decimals = getCurrencyDecimals(currency)
  if (!/^(?:0|[1-9]\d*)(?:\.\d+)?$/.test(normalized)) return null
  const [whole, fraction = ""] = normalized.split(".")
  if (fraction.length > decimals || !Number.isFinite(Number(normalized)) || Number(normalized) <= 0) return null
  return decimals ? `${whole}.${fraction.padEnd(decimals, "0")}` : whole
}

/** Legacy decimal columns may serialize whole-unit money as "123.00". */
export function storedMoneyInput(value: string | number, currency: string): string {
  const text = String(value)
  return getCurrencyDecimals(currency) === 0 ? text.replace(/\.00$/, "") : text
}

export const kindForPaymentMethod = (method: string): "cash" | "bank" | "clearing" | undefined =>
  method === "cash" ? "cash" : method === "bank-transfer" ? "bank" : method === "card" ? "clearing" : undefined

export const financeToday = (timezone?: string) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: timezone || "UTC", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date())

/**
 * Who may receive a pending transfer into an account (Confirm received funds).
 * Mirrors PaymentPolicy::settle: recording or confirming money does, unless
 * the clinic keeps receiving to `payments.confirm` alone (ArtDent 261003).
 */
export const canReceiveTransfers = (permissions: readonly string[] | undefined, confirmOnly: boolean): boolean =>
  !!permissions && (permissions.includes("payments.confirm") || (!confirmOnly && permissions.includes("payments.create")))
